import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './btn.css';

class Btn extends Component {

    render() {

        return (
            <a
                className="Btn"
                target="_blank"
                href={this.props.href}
            >
                {this.props.text}
            </a>
        );

    }
}

Btn.propTypes = {
    text: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
}

export default Btn;




// WEBPACK FOOTER //
// ./src/components/btn/index.js